import {
  buildShiftListStatusDisplay,
} from "../../utils/shiftListStatusDisplay";

/** Client schedule summary cards (contact portal — no Pending Signoff Review). */
export const CLIENT_SCHEDULE_STAT_ORDER = [
  { type: "future", name: "Future", color: "#c1c1c1" },
  { type: "late", name: "Late", color: "#c49191" },
  { type: "checkedIn", name: "Checked In", color: "#aac4a2" },
  { type: "checkedOut", name: "Checked Out", color: "#facd91" },
  { type: "signoffPending", name: "Pending Signoff", color: "#00AAAA" },
  { type: "signoffComplete", name: "Signoff Complete", color: "#9191A6" },
  { type: "noshow", name: "No Show", color: "#facd91" },
];

/** Map resolved badge chipState → summary card type key. */
const CHIP_TO_STAT_TYPE = {
  future: "future",
  late: "late",
  checkIn: "checkedIn",
  noshow: "noshow",
  signoffPending: "signoffPending",
  signoffPendingReview: "signoffPending",
  signoffComplete: "signoffComplete",
};

function hasCheckoutDate(shift) {
  return !!(shift?.checkout_date && String(shift.checkout_date).trim());
}

/** Returns one or more summary card buckets for a shift (legacy allows overlap). */
function chipStateToStatTypes(chipState, shift) {
  if (chipState === "signoffComplete") {
    return ["signoffComplete"];
  }

  const types = [];
  const baseType = CHIP_TO_STAT_TYPE[chipState];
  if (baseType) types.push(baseType);

  if (
    hasCheckoutDate(shift) &&
    (chipState === "signoffPending" || chipState === "signoffPendingReview")
  ) {
    if (!types.includes("checkedOut")) types.push("checkedOut");
  }

  return types;
}

function shiftRowForStatus(shift) {
  return {
    checkInState: shift.checkInState,
    checkin_date: shift.checkin_date,
    checkout_date: shift.checkout_date,
    checkin_unpaid_break_minutes: shift.checkin_unpaid_break_minutes,
    signoff_state: shift.signoff_state,
    actual_state: shift.actual_state,
    start_date: shift.start_date,
    end_date: shift.end_date,
    unpaid_break: shift.unpaid_break,
    checkin_signoff_date: shift.checkin_signoff_date,
  };
}

/** Count shifts using the same status logic as ClientScheduleCheckInBadge. */
export function computeClientScheduleStats(shifts = []) {
  const counts = Object.fromEntries(
    CLIENT_SCHEDULE_STAT_ORDER.map((s) => [s.type, 0]),
  );

  for (const shift of shifts || []) {
    const { chipState } = buildShiftListStatusDisplay(shiftRowForStatus(shift));
    for (const statType of chipStateToStatTypes(chipState, shift)) {
      if (counts[statType] != null) {
        counts[statType] += 1;
      }
    }
  }

  return CLIENT_SCHEDULE_STAT_ORDER.map((def) => ({
    type: def.type,
    name: def.name,
    value: counts[def.type] || 0,
  }));
}
